export default __webpack_public_path__ + "static/2.2_EN-e60e7cdafe347ee94929c358d8d7dcbd.webp";